import { configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import feedManagerReducer from "./modules/feedManager/store";
import toastReducer from "./modules/toast/store";
import statusBarReducer from "./taskpane/components/statusBar/store";
import securitiesUpdatedStagedReducer from "./service/store";

export const store = configureStore({
  reducer: {
    feedManager: feedManagerReducer,
    toast: toastReducer,
    statusBar: statusBarReducer,
    securitiesUpdatedStaged: securitiesUpdatedStagedReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
